import { useState, useCallback, useEffect } from 'react';
import { DEFAULT_FORM_DATA, notificationToForm, scheduleValidationError } from '../utils';

export const useNotificationForm = (initialNotification = null) => {
  const [formData, setFormData] = useState(
    initialNotification ? notificationToForm(initialNotification) : DEFAULT_FORM_DATA
  );

  // Reset form when initialNotification changes
  useEffect(() => {
    if (initialNotification) {
      setFormData(notificationToForm(initialNotification));
    } else {
      setFormData(DEFAULT_FORM_DATA);
    }
  }, [initialNotification]);

  const updateField = useCallback((field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  }, []);

  const togglePlatform = useCallback((platform) => {
    setFormData((prev) => ({
      ...prev,
      platforms: prev.platforms.includes(platform)
        ? prev.platforms.filter((p) => p !== platform)
        : [...prev.platforms, platform],
    }));
  }, []);

  const setUrgency = useCallback((urgency) => {
    setFormData((prev) => ({ ...prev, urgency }));
  }, []);

  const toggleSchedule = useCallback(() => {
    setFormData((prev) => ({ ...prev, isScheduled: !prev.isScheduled }));
  }, []);

  const resetForm = useCallback(() => {
    setFormData(DEFAULT_FORM_DATA);
  }, []);

  return {
    formData,
    updateField,
    togglePlatform,
    setUrgency,
    toggleSchedule,
    resetForm,
    characterCount: formData.notificationMessage.length,
    scheduleError: scheduleValidationError(formData),
  };
};
